export const MenuData: { [key: string]: { [key: string]: { title: string; link: string }[] } } = {
  OFFLINE: {},
  PUB: {
    Consultations: [
      {
        title: 'Nouvelle',
        link: '/login',
      },
      {
        title: 'Historique',
        link: '/tst',
      },
    ],
  },
  ENT: {
    Consultations: [
      {
        title: 'Historique',
        link: '/login',
      },
    ],
  },
  COM: {
    Consultations: [
      {
        title: 'Test1',
        link: '/login',
      },
    ],
  },
};
